module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "add button is-large is-warning",
    attrs: {
      "to": {
        name: _vm.destination
      }
    }
  }, [_c('span', {
    staticClass: "icon is-medium"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-874b5a98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseRouterRoundButton.vue
// module id = 323
// module chunks = 2